const Concern = (props: any) => {
    const { children, node } = props
    return (
        <>
            <div
                className={`concern-wrap poa-pdf-form-heading ${
                    node?.configurations?.find(
                        (c: { key: string; value: string }) =>
                            c.key === 'hasConcern'
                    )?.value === 'true'
                        ? 'red'
                        : ''
                }`}
            >
                {node?.title}
            </div>
            {children}
        </>
    )

}
export default Concern;